import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useCollections } from '../store/CollectionContext';
import { usePatternContext } from '../store/PatternContext';
import { backPage, selectCurrentCollectionId, setCurrentCollectionId, setCurrentPattern, setPage, setPatternType } from '../store/patternManagerSlice';
import { PatternType, StoredPattern } from '../types/pattern.model';

import PatternCard from './PatternCard';
import ArchiveFilterDropdown, { ArchiveFilter, matchesArchiveFilter } from './ArchiveFilterDropdown';
import LeftArrow from '../icons/LeftArrow';

const CollectionDetail: React.FC = () => {
  const collectionId = useSelector(selectCurrentCollectionId);
  const { collections } = useCollections();
  const { patterns } = usePatternContext();
  const dispatch = useDispatch();

  const [archiveFilter, setArchiveFilter] = useState<ArchiveFilter>('active');

  const collection = collections.find(c => c.id === collectionId);

  const back = () => {
    dispatch(setCurrentCollectionId(null));
    dispatch(backPage());
  };

  const editPattern = (patternType: PatternType, pattern: StoredPattern) => {
    dispatch(setPatternType(patternType));
    dispatch(setCurrentPattern(pattern));
    dispatch(setPage('edit'));
  };

  const patternsInCollection: [PatternType, StoredPattern][] = (['lightning', 'twisted-stripe'] as PatternType[])
    .flatMap(patternType => patterns[patternType]
      .filter(p => p.collectionId === collectionId && matchesArchiveFilter(p, archiveFilter))
      .map((pattern): [PatternType, StoredPattern] => [patternType, pattern]));

  return (
    <div className="flex flex-col items-center w-full">
      <div className='flex items-start w-full gap-2 mt-4 mb-2 px-4 cursor-pointer' onClick={back}>
        <div className="flex items-center"><LeftArrow /></div>
        <p className='text-sm'>Your Collections</p>
      </div>
      <div className="flex items-center gap-2 mt-2 mb-2">
        <p className="text-lg">{collection?.name ?? 'Collection'}</p>
      </div>
      <div className="flex w-3/4 justify-end mb-4">
        <ArchiveFilterDropdown filter={archiveFilter} onFilterSelect={setArchiveFilter} />
      </div>
      <div className='flex w-3/4 justify-center flex-wrap gap-2'>
        {
          patternsInCollection.map(([patternType, pattern]) => (
            <PatternCard key={pattern.id} pattern={pattern} patternType={patternType} onClick={() => editPattern(patternType, pattern)} />
          ))
        }
      </div>
    </div>
  );
};

export default CollectionDetail;
